<template>
  <el-skeleton v-if="isInitialLoading" animated
    ><template #template>
      <el-skeleton-item
        variant="rect"
        class="insights-ia-page__skeleton-item"
        style="height: 75vh; width: 100%; margin-top: 7px"
      />
    </template>
  </el-skeleton>

  <div v-else class="insights-agente-de-dre">
    <InsigthsOptinFrame v-if="!hasOptin" />
    <div class="agente-dre-insights-page" v-else>
      <AnaliseInteligenteInsigthsDre />

      <InsightProcessandoFrame v-if="processando" />

      <InsightsIAList
        v-else-if="ativado"
        @ExportData="handleExportData"
        @csatFeedback="handleCsatFeedback"
      />

      <InsigthDesativadoFrame v-else />
    </div>

    <InsightConfiguracaoDialog
      v-model="isSettingsDrawerOpen"
      :tipo="ETipoConfiguracao.ATIVAR"
      :gerarRelatorio="true"
    />

    <ExportarRelatorioDREDialog v-model="isExportarRelatorioDREDialogOpen" />
  </div>
</template>

<script setup lang="ts">
import InsigthsOptinFrame from "./widgets/optin/InsigthsOptinFrame.vue";
import { storeToRefs } from "pinia";
import { onMounted, ref } from "vue";
import AnaliseInteligenteInsigthsDre from "./widgets/analiseInteligente/AnaliseInteligenteInsigthsDre.vue";
import InsightsIAList from "./widgets/insights/InsightsIAList.vue";
import InsightConfiguracaoDialog from "../../widgets/configuracao/InsightConfiguracaoDialog.vue";
import InsigthDesativadoFrame from "./widgets/desativado/InsigthDesativadoFrame.vue";
import InsightProcessandoFrame from "./widgets/processando/InsightProcessandoFrame.vue";
import ExportarRelatorioDREDialog from "@/features/financas/widgets/ExportarRelatorioDRE/ExportarRelatorioDREDialog.vue";
import { ETipoConfiguracao } from "../../widgets/configuracao/types";
import { useAgenteDeDreInsigthsStore } from "./store/useAgenteDeDreInsigthsStore.js";

const isSettingsDrawerOpen = ref(false);
const isExportarRelatorioDREDialogOpen = ref(false);

const agenteDeDreInsigthsStore = useAgenteDeDreInsigthsStore();

const { hasOptin, ativado, processando, isInitialLoading } = storeToRefs(
  agenteDeDreInsigthsStore
);

const handleExportData = () => {
  isExportarRelatorioDREDialogOpen.value = true;
};

const handleCsatFeedback = async (value: {
  feedback: "true" | "false";
  id: string;
}) => {
  try {
    await agenteDeDreInsigthsStore.gateway.avaliarInsight({
      idInsight: value.id,
      usefulInsight: value.feedback === "true" ? true : false
    });
  } catch {
    agenteDeDreInsigthsStore.setLoading(false);
  }
};

const handleVerificarOptIn = async () => {
  try {
    agenteDeDreInsigthsStore.setIsInitialLoading(true);

    await agenteDeDreInsigthsStore.fetchVerificarOptIn().then(() => {
      if (hasOptin.value) agenteDeDreInsigthsStore.fetchObterConfiguracao();
    });
  } catch (error) {
    console.error(error);
  } finally {
    agenteDeDreInsigthsStore.setIsInitialLoading(false);
  }
};

onMounted(async () => {
  await handleVerificarOptIn();
});
</script>

<style scoped lang="scss">
.insights-agente-de-dre {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  .agente-dre-insights-page {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    gap: 0;
    border-radius: 5px;

    > :first-child {
      flex-shrink: 0;
    }

    :deep(.insights-agente-body-frame) {
      margin-top: 8px;

      .f360-screen-frame__basecontent {
        margin-top: 0;
        border-radius: 5px;
      }
    }

    &__controls {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 8px;
      align-items: center;
      margin-top: 12px;
    }

    @media screen and (max-width: 1024px) {
      &__controls {
        grid-template-columns: 1fr;
      }
    }
  }
}
</style>
